import React, { useEffect, useState } from "react";
import { Container, Flex, Link as ChakraLink, Text } from "@chakra-ui/react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { appRoutes } from "../../../App";
import { t } from "i18next";
import { CraCommentApi } from "../../coding/services/CraCommentApi";
import {
  AppHeader,
  AppHeaderHeight,
} from "../../shared/views/AppHeader/AppHeader";
import { LoadingScreen } from "../../shared/views/LoadingScreen/LoadingScreen";
import { CraWayApi } from "../../cra/services/CraWayApi";

export const CommentRedirectPage: React.FC = () => {
  const commentId = useParams().commentId!;

  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  const loadContextAndRedirect = async () => {
    const comment = await CraCommentApi.get(commentId).then((r) => r.data);
    const craWay = await CraWayApi.get(comment.craWayId).then((r) => r.data);

    const urlParams = new URLSearchParams();
    urlParams.append("craWayId", craWay.id);

    if (comment.craNodeId) {
      urlParams.append("craNodeId", comment.craNodeId);
    }

    if (craWay.permissions.canCode || craWay.permissions.canComment) {
      navigate(`${appRoutes.survey(craWay.surveyId)}?${urlParams.toString()}`);
    } else {
      setShowError(true);
    }
  };

  useEffect(() => {
    loadContextAndRedirect().catch(() => {
      setShowError(true);
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Flex flexDir="column" maxHeight="100vh" flexGrow={1} position="relative">
      <AppHeader />
      <AppHeaderHeight />

      {showError ? (
        <Container py={8}>
          <Text fontSize="2xl">{t(`map:comments.unavailable`)}</Text>
          <ChakraLink color="primary.600">
            <Link to={"/"}>{t(`map:comments.goHome`)}</Link>
          </ChakraLink>
        </Container>
      ) : (
        <LoadingScreen />
      )}
    </Flex>
  );
};
